module.exports = __webpack_public_path__ + "static/img/SEC.f963f4f3.jpg";